import { QueryParams } from "@/models/query-params.model";
import { QuizIndividualStudent } from "@/models/stats.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { GenericsUtils } from "@/utils/generics.util";
import { BehaviorSubject, Observable, map } from "rxjs";

export class DraftsFeedbacksService {
  private classroomId: string | undefined;

  constructor(private _stats = new StatsRest()) {
    this.classroomId = localStorage.getItem("objClassroomId") ?? undefined;
  }

  private draftsFeedbacks$: BehaviorSubject<any> =
    new BehaviorSubject<QuizIndividualStudent>(new QuizIndividualStudent());
  draftsFeedbacks: Observable<QuizIndividualStudent> =
    this.draftsFeedbacks$.asObservable();

  getDraftsFeedbacksFromObjective(
    courseId: string,
    objectiveId: string,
    params: QueryParams
  ): void {
    this._stats
      .getDraftsFeedbacksFromObjective(courseId, objectiveId, {
        ...params,
        classroomId: this.classroomId,
      })
      .pipe(
        map((e: any) => {
          e.content.forEach((item: any) => {
            item.completeUserName = item.userName;
            item.userName = this.extractFirstAndLastName(item.userName);
            item.completeUserEmail = item.userEmail;
            item.userEmail = this.adjustText(item.userEmail, 20);
            item.completeFeedbackText = item.feedbackText;
            item.feedbackText = item.feedbackText
              ? this.adjustText(item.feedbackText, 20)
              : "-";
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.draftsFeedbacks$.next(response);
        },
      });
  }
  getStatus(status: boolean): string {
    let result = "";
    if (status) {
      result = GenericsUtils.translateI18n(
        "stats.course.students.status.approved"
      );
    } else {
      result = GenericsUtils.translateI18n(
        "stats.course.students.status.failed"
      );
    }
    return result;
  }

  getStatusColor(status: string): string {
    if (status) {
      status = "bg-h-success-100 text-h-success-80";
    } else {
      status = "bg-h-error-100 text-h-error-800";
    }
    return status;
  }

  remakeObjectStatus(item: any): any {
    var status = { name: "", class: "", value: "" };
    status.name = this.getStatus(item);
    status.class = this.getStatusColor(item);
    status.value = item;
    return status;
  }
  adjustText(text: string, size: number): string {
    if (text.length > size) {
      text = text.substring(0, size) + "...";
    }
    return text;
  }
  extractFirstAndLastName(fullName: string): string {
    const nameParts = fullName.split(" ");
    const firstName = nameParts[0];
    const lastName = nameParts[nameParts.length - 1];

    return firstName + " " + lastName;
  }
}
